import { Trans } from '@lingui/react/macro';
import React from 'react';

import { UDSkeletonText } from 'ud-ui/components/skeleton';
import UDText from 'ud-ui/components/text';
import { MATCH_PREVIEW_LOGO_SIZE, MATCH_PREVIEW_PLATE_CLASS } from './news-ticker-layout';

/** Сколько записей рисует скелетон: хватает, чтобы занять плашку на широком экране; лишнее срезает `overflow-hidden`. */
const SKELETON_ITEMS = 4;

/** Колонка эмблемы: круг и плашка счёта под ним. */
const LogoColumn = () => (
  <div className="flex flex-col items-center gap-0.5">
    <div
      className="skeleton-block rounded-pill shrink-0"
      style={{ width: MATCH_PREVIEW_LOGO_SIZE, height: MATCH_PREVIEW_LOGO_SIZE }}
    />
    <UDSkeletonText variant="text-2-bold" className="w-3" />
  </div>
);

/**
 * Скелетон записи ленты: превью на тех же классах плашки, что у живого (`MATCH_PREVIEW_PLATE_CLASS`), «vs» —
 * настоящий, но невидимый, чтобы плашка вышла той же ширины, а справа — строки времени и результата
 * тех же вариантов `UDText` и той же колонки `w-48`, что у `NewsTickerItem`.
 */
const NewsTickerSkeletonItem = () => (
  <div className="rounded-card flex shrink-0 items-center gap-3 px-2.5 py-2">
    <div className={MATCH_PREVIEW_PLATE_CLASS}>
      <LogoColumn />
      <UDText variant="subtitle-2" as="span" className="flex h-9 items-center text-transparent" aria-hidden>
        <Trans>vs</Trans>
      </UDText>
      <LogoColumn />
    </div>
    <span className="flex w-48 flex-col gap-1" aria-hidden>
      <UDSkeletonText variant="subtitle-2" className="w-24" />
      <span className="flex flex-col">
        <UDSkeletonText variant="text-2-medium" relaxed className="w-full" />
        <UDSkeletonText variant="text-2-medium" relaxed className="w-2/3" />
      </span>
    </span>
  </div>
);

/** Скелетон бегущей строки: несколько записей в ряд, обрезанных по краю плашки. */
const NewsTickerSkeleton = () => (
  <div className="flex overflow-hidden" aria-busy data-testid="news-ticker-skeleton">
    {Array.from({ length: SKELETON_ITEMS }, (_, index) => (
      <NewsTickerSkeletonItem key={index} />
    ))}
  </div>
);

export default NewsTickerSkeleton;
